import { TextNode } from 'lexical';

import { $createWhitespace } from 'lib/textEditor';
import { toUsernameWithAtSign } from 'lib/user';

class MentionNode extends TextNode {
  __mention;

  constructor(mentionName, key) {
    const mention = toUsernameWithAtSign(mentionName);

    super(mention, key);
    this.__mention = mention;
  }

  static clone(node) {
    return new MentionNode(node.__text.replace('@', ''), node.__key);
  }

  static getType() {
    return 'mention';
  }

  static importJSON(serializedNode) {
    const node = $createMentionNode(serializedNode.mentionName);

    node.setTextContent(serializedNode.text);
    node.setFormat(serializedNode.format);
    node.setDetail(serializedNode.detail);
    node.setMode(serializedNode.mode);
    node.setStyle(serializedNode.style);

    return node;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      mentionName: this.__mention,
      type: 'mention',
      version: 1,
    };
  }

  createDOM(config) {
    const dom = super.createDOM(config);

    dom.className = 'text-primary-400 dark:text-primary-200';

    return dom;
  }

  updateDOM() {
    return false;
  }

  exportDOM() {
    /**
     * Sometimes the comment processing can accidentally purge plain whitespaces
     * at final of a HTML tag, so we use special entity instead.
     */
    return { element: this.__text.replace(' ', '&nbsp;') };
  }

  static importDOM() {
    return {
      span: (domNode) => {
        if (!domNode.innerHTML.includes('@')) {
          return null;
        }

        return {
          conversion: convertMentionElement,
          priority: 1,
        };
      },
    };
  }

  isTextEntity() {
    return true;
  }

  canInsertTextBefore() {
    return false;
  }

  canInsertTextAfter() {
    return false;
  }
}

const convertMentionElement = (domNode) => {
  const textContent = domNode.textContent;

  if (textContent !== null) {
    return {
      node: [$createMentionNode(textContent), $createWhitespace()],
    };
  }

  return null;
};

export const $createMentionNode = (mentionName) => {
  const mentionNode = new MentionNode(mentionName.replace('@', ''));

  mentionNode.setMode('segmented').toggleDirectionless();

  return mentionNode;
};

export const $addMentionNodeConfig = (nodes) => {
  nodes.push(MentionNode);
};

export default MentionNode;
